/* sb-dc-stkprice.js - price the free-size stickers off the product page's own
   table instead of a per-square-foot formula. 2026-09-16.

   WHAT WAS WRONG. The design center worked out a sticker's price from its
   area: a rate per square foot, multiplied out. The product page does not
   price them that way at all. It carries a table per variant - a per-piece
   price at 25, 50, 100, 250, 500, 1,000, 2,000, 5,000 and 10,000 pieces - and
   that per-piece price FLATTENS as the sticker gets bigger (Bumper stops
   around $1.98, Kiss-Cut around $4.20). Multiplying by area never flattens,
   so the two drifted apart the larger the sticker got.

   Measured 2026-09-16, per piece at 25 pcs:

     Bumper    121 sizes, 84 disagreed.  12"x12": page $1.98, editor $5.76
     Kiss-Cut  121 sizes, 105 disagreed. 11"x12": page $4.20, editor $14.85
     Round      4 sizes, all agreed
     Oval       9 sizes, all agreed

   The page is right, and the page is also what the customer is charged: a
   12"x4" Bumper at 25 pcs was quoted $48.00 in the editor and went into the
   cart at $40.00. So the editor was frightening people with a number nobody
   ever pays. Owner confirmed the product page is the correct price
   (2026-09-16).

   WHERE THE NUMBERS COME FROM. Each product page prints its own table as
   <script id="tier-data-json">, keyed by variant id. This reads that, plus
   /products/<handle>.js for the id -> "W / H / Material" titles, and builds

       "12/4/regular" -> { base: 0.88, tiers: [{min:25,price:1.6}, ...] }

   One pair of fetches per product, cached for the page. Until they land the
   original functions answer, so a slow network shows the old number for a
   moment rather than no number at all.

   WHAT IT OVERRIDES. Four readers the bundle exposes, and only when this
   product and size are in the table - anything else falls straight through:

       __dcSubtotal    the Total
       __dcHeadPrice   the "$1.92/pc (at 25 pcs)" line
       __dcTierTable   the quantity ladder and its "% off" labels
       __dcRate        the per-square-foot figure the unit price is drawn from

   __dcNextTier needs no wrapper: it reads __dcTierTable, so it follows.

   Round and Oval stickers read the page table as well (since 2026-10-16,
   price set A). Their titles are shapes - '2" Round / Material' is 2x2,
   '3"x2" Oval / Material' is 3x2 and 2x3 - and before that change the
   bundle's own fixed tables answered for them.

   THE CART IS NOT AFFECTED. The line price is set by the store's quantity
   tier app when the item is added, and always was. This only changes what the
   customer is shown, so that it matches what they will be charged.

   Diagnostics: window.__dcStkPrice() - what loaded, and what it answered. */
(function () {
  "use strict";

  var info = { loaded: {}, failed: {}, hits: 0, misses: 0, wrapped: false };
  window.__dcStkPrice = function () { return info; };

  var TABLES = {};        // handle -> { key -> {base, tiers} }
  var PENDING = {};

  function root() {
    try {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    } catch (e) { return "/"; }
  }

  function applied() {
    try { return (window.__dcAppliedProduct && window.__dcAppliedProduct()) || null; }
    catch (e) { return null; }
  }

  function spec() {
    try { return (window.__dcApi && window.__dcApi.spec) || null; }
    catch (e) { return null; }
  }

  /* The size the editor is drawing RIGHT NOW, in inches.

     __dcApi.spec is the wrong thing to read here. On a size change the editor
     re-renders with the new size before that object catches up, so a reader
     that goes to spec answers with the previous size and the panel lags a
     step behind - the Total was right while the "% off" line underneath still
     described the size before it.

     The bundle's own readers do not use spec either: they use the width and
     height the editor hands to __dcRate as it renders. The wrapper below
     records exactly that, so everything here is on the same clock as the
     bundle. Falls back to spec before the first __dcRate call. */
  var lastW = 0, lastH = 0;

  function sizeNow() {
    if (lastW > 0 && lastH > 0) return { w: lastW, h: lastH };
    var sp = spec();
    return sp ? { w: sp.widthIn, h: sp.heightIn } : null;
  }

  /* "Oracal 4 mil Removable Vinyl" -> removable, everything else -> regular.
     The editor keeps the same two words in spec.material. */
  function matWord(s) {
    return /removable/i.test(String(s || "")) ? "removable" : "regular";
  }

  function keyOf(wIn, hIn, material) {
    return Math.round(wIn) + "/" + Math.round(hIn) + "/" + matWord(material);
  }

  function parseTable(handle, html, variants) {
    var m = html.match(/id=["']tier-data-json["'][^>]*>([\s\S]*?)<\/script>/);
    if (!m) { info.failed[handle] = "no tier-data-json"; return; }
    var raw;
    try { raw = JSON.parse(m[1]); } catch (e) { info.failed[handle] = "bad json"; return; }

    var byId = {};
    variants.forEach(function (v) { byId[v.id] = v.title; });

    var out = {}, rows = 0;
    Object.keys(raw).forEach(function (id) {
      var title = byId[id];
      if (!title) return;
      var d = raw[id] || {};
      var tiers = (d.tiers || []).slice().sort(function (a, b) { return a.min - b.min; });
      var row = { base: d.base_price, tiers: tiers };
      var t = /^\s*(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)\s*\/\s*(.+)$/.exec(title);
      if (t) {
        out[keyOf(+t[1], +t[2], t[3])] = row;
        rows++;
        return;
      }
      /* 2026-10-16: Round ('2" Round / Material') and Oval ('3"x2" Oval /
         Material') read the page table too, so a price change on the page
         reaches the editor without a second copy to keep in step. An oval is
         registered both ways round, since the editor may hold it either way. */
      var r = /^\s*(\d+(?:\.\d+)?)\s*["\u201d\u2033]?\s*Round\s*\/\s*(.+)$/i.exec(title);
      if (r) {
        out[keyOf(+r[1], +r[1], r[2])] = row;
        rows++;
        return;
      }
      var o = /^\s*(\d+(?:\.\d+)?)\s*["\u201d\u2033]?\s*x\s*(\d+(?:\.\d+)?)\s*["\u201d\u2033]?\s*Oval\s*\/\s*(.+)$/i.exec(title);
      if (o) {
        out[keyOf(+o[1], +o[2], o[3])] = row;
        out[keyOf(+o[2], +o[1], o[3])] = row;
        rows++;
      }
    });

    if (!rows) { info.failed[handle] = "no sized variants"; return; }
    TABLES[handle] = out;
    info.loaded[handle] = rows;
  }

  function load(handle) {
    if (!handle || TABLES[handle] || PENDING[handle] || info.failed[handle]) return;
    PENDING[handle] = true;
    var base = root() + "products/" + encodeURIComponent(handle);
    Promise.all([
      fetch(base).then(function (r) { return r.ok ? r.text() : ""; }),
      fetch(base + ".js").then(function (r) { return r.ok ? r.json() : null; })
    ]).then(function (res) {
      if (res[0] && res[1] && res[1].variants) parseTable(handle, res[0], res[1].variants);
      else info.failed[handle] = "fetch failed";
      /* 2026-10-16: the editor paints its first Total before this table lands,
         so that first number came from the bundle and stayed until the
         customer touched something. Re-render once, the same nudge
         sb-dc-ratefix.js uses, so the page's own price shows straight away. */
      if (TABLES[handle]) {
        var ap = applied();
        if (ap && ap.handle === handle && window.__dcApi && window.__dcApi.setSpec) {
          try { window.__dcApi.setSpec({}, false); info.repainted = handle; } catch (e) {}
        }
      }
    }).catch(function () {
      info.failed[handle] = "fetch threw";
    }).then(function () { PENDING[handle] = false; });
  }

  /* Per-piece price for this product / size / material at this quantity, or
     null when we have nothing to say about it. The Total is asked for a
     particular spec, so it hands its own material in; the panel readers have
     no spec of their own and fall back to whatever is selected now. */
  function perPiece(p, wIn, hIn, qty, material) {
    if (!p || !p.handle) return null;
    var tbl = TABLES[p.handle];
    if (!tbl) { load(p.handle); return null; }
    if (material == null) { var sp = spec(); material = sp && sp.material; }
    var row = tbl[keyOf(wIn, hIn, material)];
    if (!row) { info.misses++; return null; }
    var q = +qty || 0;
    var price = row.base;
    for (var i = 0; i < row.tiers.length; i++) {
      if (q >= row.tiers[i].min) price = row.tiers[i].price;
    }
    if (!(price > 0)) return null;
    info.hits++;
    return price;
  }

  function r2(n) { return Math.round(n * 100) / 100; }

  function money(n) {
    try {
      return "$" + Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (e) { return "$" + n; }
  }

  function wrap() {
    if (info.wrapped) return true;
    if (typeof window.__dcSubtotal !== "function") return false;

    var prevSub = window.__dcSubtotal;
    window.__dcSubtotal = function (sp, unit) {
      var p = applied();
      if (p && sp) {
        var pp = perPiece(p, sp.widthIn, sp.heightIn, sp.quantity, sp.material);
        if (pp != null) return r2(pp * (+sp.quantity || 0));
      }
      return prevSub.apply(this, arguments);
    };

    var prevHead = window.__dcHeadPrice;
    if (typeof prevHead === "function") {
      window.__dcHeadPrice = function () {
        var p = applied(), sp = spec(), sz = sizeNow();
        if (p && sp && sz) {
          var pp = perPiece(p, sz.w, sz.h, sp.quantity);
          if (pp != null) {
            return money(pp) + "/pc (at " + (+sp.quantity || 0).toLocaleString() + " pcs)";
          }
        }
        return prevHead.apply(this, arguments);
      };
    }

    var prevTable = window.__dcTierTable;
    if (typeof prevTable === "function") {
      window.__dcTierTable = function () {
        var p = applied(), sz = sizeNow();
        if (p && sz) {
          var qs = window.__dcStkQty;
          if (qs && qs.length) {
            var base = perPiece(p, sz.w, sz.h, qs[0]);
            if (base != null && base > 0) {
              return qs.map(function (q) {
                var pp = perPiece(p, sz.w, sz.h, q);
                var d = (pp != null) ? Math.max(0, 1 - pp / base) : 0;
                return { minQty: q, maxQty: null, discount: d, label: q.toLocaleString() };
              });
            }
          }
        }
        return prevTable.apply(this, arguments);
      };
    }

    /* __dcRate answers in price per square foot, and the bundle also uses the
       call to remember the last size, so the original runs first for its side
       effects and only the number is replaced. */
    var prevRate = window.__dcRate;
    if (typeof prevRate === "function") {
      window.__dcRate = function (w, h, q) {
        var orig = prevRate.apply(this, arguments);
        if (w > 0 && h > 0) { lastW = w * 12; lastH = h * 12; }
        var p = applied();
        if (p && w > 0 && h > 0) {
          var sp = spec();
          var qty = q || (sp && sp.quantity) || 0;
          var pp = perPiece(p, lastW, lastH, qty);
          if (pp != null) return pp / (w * h);
        }
        return orig;
      };
    }

    info.wrapped = true;
    return true;
  }

  /* The applied product can change at any time (the CHOOSE PRODUCT popup), so
     keep an eye on it and fetch each new one once. */
  function tick() {
    wrap();
    var p = applied();
    if (p && p.handle) load(p.handle);
  }

  tick();
  var t = setInterval(tick, 700);
  addEventListener("pagehide", function () { clearInterval(t); });
})();
